// Should be the same as on the backend src/constants/errors.enum.ts
export enum Errors {
  SERVER_ERROR = 'SERVER_ERROR',
  WRONG_FILE_TYPE = 'WRONG_FILE_TYPE',
  WRONG_FILE_SIZE = 'WRONG_FILE_SIZE',
  MISSING_FILE = 'MISSING_FILE',
}
